import { render, staticRenderFns } from "./HighwayResolution.vue?vue&type=template&id=134c11ff"
import script from "./HighwayResolution.vue?vue&type=script&lang=js"
export * from "./HighwayResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports